import { BookingDialogActionType } from "../Actions";
import { IPassengersAndPaymentState, IProduct, ISeat, IVoucher } from "../Models";

export const createPassengersAndPaymentReducer = (initialState: IPassengersAndPaymentState = null) => {

	initialState = setInitialState(initialState);

	return (state: IPassengersAndPaymentState = initialState, action: { type?: BookingDialogActionType }): IPassengersAndPaymentState => {
		switch(action.type) {
			case "createBookingComplete":
				return { ...state, ...{ booking: (action as any).payload }};
			case "cancelBookingStarted":
				return { ...state, ...{ booking: null, vouchers: [] } };
			case "verifyVoucherComplete":
				return addVoucher(state, (action as any).payload);
			case "verifyDiscountCodeComplete":
				return addDiscountCode(state, (action as any).payload);
			case "clearDiscountCodes":
				return { ...state, ...{ discountCodes: null }}
			case "openSeatmap":
				return { ...state, ...{ seatChange: { ...state.seatChange, ...{
							tariffSegment: (action as any).tariffSegment,
							selectedSeats: (action as any).tariffSegment.requiredProducts.map((x: IProduct) => ({ itemId: x.itemId, seat: x.seat }) )
						} } } };
			case "closeSeatmap":
				return { ...state, ...{ seatChange: { ...state.seatChange, ...{ tariffSegment: null, selectedSeats: [] } } } };
			case "getCarriageLayoutComplete":
				return { ...state, ...{ seatChange: { ...state.seatChange, ...{ carriageLayout: (action as any).payload } } } }; //TODO: Kanske måste kolla att vi är på rätt segment fortfarance
			case "selectSeat":
				return seatSelected(state, (action as any));
			case "updateSeatsComplete":
				return { ...state, ...{ booking: (action as any).payload }};
			case "finalizeBookingStarted":
				return { ...state, ...{
					booking: { ...state.booking, ...{ isFinalized: false }},
					paymentMethod: (action as any).meta.paymentMethod,
					paymentData: undefined
				}};
			case "finalizeBookingComplete":
				return { ...state, ...{ booking: { ...state.booking, ...{ isFinalized: true }}, paymentData: (action as any).payload }};
			case "abortPayment":
				return { ...state, ...{
					paymentMethod: undefined, paymentData: undefined
				}};
			case "fakePaymentComplete":
				return { ...state, ...{
					booking: { ...state.booking, ...{ isPaid: true }}
				}};
			default:
				return state;
		}
	};

	function setInitialState(initialState: IPassengersAndPaymentState): IPassengersAndPaymentState {
		return {...initialState, ...{ }};
	}
};

function addVoucher(state: IPassengersAndPaymentState, voucher: IVoucher): IPassengersAndPaymentState
{
	let vouchers = state.vouchers ? [...state.vouchers] : [];
	vouchers.push(voucher);
	return {...state, ...{ vouchers} };
}

function addDiscountCode(state: IPassengersAndPaymentState, voucher: IVoucher): IPassengersAndPaymentState
{
	let discountCodes = state.discountCodes ? [...state.discountCodes] : [];
	discountCodes.push(voucher);
	return {...state, ...{ discountCodes } };
}

function seatSelected(state: IPassengersAndPaymentState, action: { itemId: string, seat: ISeat }) : IPassengersAndPaymentState
{
	const selectedSeats = [...state.seatChange.selectedSeats];
	const idx = selectedSeats.findIndex(x => x.itemId === action.itemId);
	if (idx >= 0)
		selectedSeats[idx] = { itemId: action.itemId, seat: action.seat };
	else
		selectedSeats.push({ itemId: action.itemId, seat: action.seat });
	return { ...state, ...{ seatChange: { ...state.seatChange, ...{ selectedSeats } } }};
}